export const ADDRESS_MAPPER: { [name: string]: string } = {
  "0x0262d4aa38bbb8a52b6b5b7131e3e25bf0f3459e": "Angel",
  "0xbd9ebfe0e6e909e56f1fd3346d0118b7db49ca15": "MoraSwap",
};
